import { FontSource } from '../theme-types';

export const themeVariables = {
  // Font definitions
  fontSource: FontSource.Local,
};

